exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-align-bottom[data-v-0ecfcf9a] {\n  align-self: flex-end;\n}\n.flex[data-v-0ecfcf9a] {\n  display: flex;\n}\n.text-capitalize[data-v-0ecfcf9a] {\n  text-transform: capitalize !important;\n}\n", ""]);

// exports
